<template>
  <div class="half-yellow-row">
    <div class="row">
      <div class="col-12 col-lg-6 colored">
        <div class="edge-top"></div>
        <div class="edge-bottom"></div>
        <slot name="left">LEFT SLOT</slot>
      </div>
      <div class="col-12 col-lg-6">
        <slot name="right">RIGHT SLOT</slot>
      </div>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$radius: 50px;
.colored {
  background-color: #ffbe17;
  min-height: 100px;
  border-radius: 0 $radius $radius 0;
  position: relative;

  .edge-top {
    width: $radius;
    height: $radius;
    top: -$radius;
    position: absolute;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: #ffbe17;
    }
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: white;
      border-radius: 0 0 0 $radius;
    }
  }
  .edge-bottom {
    width: $radius;
    height: $radius;
    bottom: -$radius;
    position: absolute;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: #ffbe17;
    }
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: white;
      border-radius: $radius 0 0 0;
    }
  }
}
</style>


<script>
export default {
  name: "HalfYellowRow",
  props: {
    msg: String
  }
};
</script>